import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledDivDefaultImage = styled(Grid, {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	background: ${Magnetic[props.backgroundImage]} no-repeat center;
	height: 360px;
    width: 100%;
    display: flex;
`);
export const StyledContent = styled('div') `
	text-align: justify;
`;
export const StyledCameraImage = styled('div', {
    shouldForwardProp: prop => prop !== 'backgroundImage'
}) `
	background-image: url(${props => props.backgroundImage});
	width: 60px;
	height: 60px;
	background-repeat: no-repeat;
	border-radius: 50%;
	background-size: cover;
	background-position: center;
`;
export const StyledDivImageContainer = styled('div') `
	position: relative;
	text-align: center;
	padding-bottom: ${Magnetic.spacer64};
	padding-top: ${Magnetic.spacer12};
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const StyleDivBaseImage = `
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: 50px;
	height: 50px;
	outline: ${Magnetic.buttonFlatBorder};
	border-radius: 100%;
	border: ${Magnetic.buttonFlatBorder};
`;
export const StyledIntelligentWideShotImageButton = styled('button', {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	${StyleDivBaseImage}	
	background-color: ${props.backgroundColor};
	color: ${Magnetic.colorWhite};
`);
//# sourceMappingURL=IntelligentWideShot.style.js.map